
import { Component, Vue } from 'vue-property-decorator'
import NewsTable from '@/components/news/newsTable.vue'
import { NewsService } from '@/services/index'

@Component({
    name: 'Career',
    components: {
        NewsTable
    }
})
export default class extends Vue {
    private reporterId: number = 0
    private newsList = []
    private pageIndex: number = 1
    private pageSize: number = 50
    private pageTotal: number = 0
    
    private mounted() {
        this.reporterId = parseInt(this.$route.params.id)
        this.getNewsList()
    }

    private async getNewsList() {
        const params = { 
            reporter_id: this.reporterId, 
            page_index: this.pageIndex, 
            page_size: this.pageSize 
        }
        const result = await NewsService.getList(params)
        if (result.status === 200) {
            this.newsList = result.data.news_list
            this.pageTotal = result.data.page_total
        }
    }

    private onAddNews() {
        const id: any = this.reporterId
        this.$router.push({ name: 'ReporterAddNews', params: { id } })
    }

    private onCurrentChange(page: any) {
        const $backtop = this.$refs.backtop as any
        this.pageIndex = page
        this.getNewsList()
        $backtop.scrollToTop()
    }
}
